import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { getTableRoutesAvailability } from 'src/routes/state/routesSelector';
import { useAppSelector } from 'src/store';
import { IndividualRouteSetting, TableViews } from 'src/routes/routesConfig';
import { Resources } from 'src/shared/types';
import useHabitatInsightsAccess from 'src/shared/hooks/useHabitatInsightsAccess';
import { useProductAccess } from 'src/shared/hooks/useProductLicensing';
import AccessGate from 'src/shared/components/product-gate/AccessGate';
import { ProductKey } from 'src/shared/types/engine/products';
import SampleMetricsTable from './sample-metrics-table/SampleMetricsTable';
import HabitatInsightsMetricsTable from './habitat-insights-metrics-table/HabitatInsightsMetricsTable';

export const tableRouteSettings: { [key in TableViews]: IndividualRouteSetting } = {
    sampleMetrics: {
        name: 'Sample Metrics Table',
        path: '/sample-metrics',
        handler: <SampleMetricsTable />,
        resource: Resources.SAMPLES_TABLE,
    },
    habitatInsightsMetrics: {
        name: 'Habitat Insights Metrics Table',
        path: '/habitat-insights-metrics',
        handler: <HabitatInsightsMetricsTable />,
        resource: Resources.HABITAT_INSIGHTS_TABLE,
    },
};
const Tables = () => {
    const routesConfig = useAppSelector(getTableRoutesAvailability);
    const habitatInsightsAccess = useHabitatInsightsAccess();
    const ednaAccess = useProductAccess(ProductKey.EDNA, false);

    return (
        <Routes>
            {Object.keys(routesConfig).map(routeKey => {
                const isAvailable = routesConfig[routeKey as TableViews];
                const routeSetting = tableRouteSettings[routeKey as TableViews];
                const isHabitatInsightsTable = routeKey === TableViews.HABITAT_INSIGHTS_METRICS;
                const product = isHabitatInsightsTable ? ProductKey.HABITAT_INSIGHTS : ProductKey.EDNA;
                const access = isHabitatInsightsTable ? habitatInsightsAccess : ednaAccess;

                return (
                    <Route
                        path={routeSetting.path}
                        element={
                            <AccessGate product={product} access={access}>
                                <ProtectedRoute isAllowed={isAvailable} redirectPath={'/projects'} routeSetting={routeSetting}>
                                    {routeSetting.handler}
                                </ProtectedRoute>
                            </AccessGate>
                        }
                        key={routeSetting.name}
                    />
                );
            })}
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
};
export default Tables;
